import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.security-scan', {
        url: '/security-scan',
        component: 'companySharingCenterSecurityScan',
        resolve: {accounts},
    });
}

/** @ngInject */
function accounts($filter, companyId, SharedAccountsService) {
    return SharedAccountsService
        .getAllByCompany({companyId}, {}).$promise
        .then(accounts => $filter('orderBy')(accounts, 'publicService.serviceName'))
        .then(accounts => accounts.map((account) => ({...account, serviceDisplayName: serviceDisplayName(account)})))
}

function serviceDisplayName(account) {
    let displayName = '';
    if (account.publicService.slug != 'other' || !account.customServiceName) {
        displayName = account.publicService.serviceName;
    } else if (account.publicService.slug == 'other'){
        displayName = account.customServiceName;
    }
    return displayName;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/security-scan/security-scan.state.js